import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getGlobalStaticData } from '../../../helpers/get-global-static-data';
import { getCentreDetails } from '../../../helpers/centre';
const buildLinkItem = (item, context) => {
  var _linkItem$label, _linkItem$url;
  const linkItem = item;
  const parentItem = item;
  const link = {
    label: (_linkItem$label = linkItem.label) !== null && _linkItem$label !== void 0 ? _linkItem$label : parentItem.title,
    url: (_linkItem$url = linkItem.url) !== null && _linkItem$url !== void 0 ? _linkItem$url : '#'
  };
  if (parentItem.key) {
    link.hamburgerMenuTarget = [context, parentItem.key];
  }
  if (parentItem.items) {
    link.simpleMenuItems = parentItem.items;
  }
  return link;
};
export async function fetchStaticData(client, options) {
  const {
    country
  } = options;
  const {
    giftCards: {
      navigationMenu: giftCardNavigationMenu,
      giftCardNavLinks
    },
    national: {
      navigationMenu: nationalExperienceNavigationMenu,
      nationalExperienceNavLinks
    },
    centres
  } = await getGlobalStaticData(client, country);
  const baseItems = {
    giftCards: giftCardNavigationMenu !== null && giftCardNavigationMenu !== void 0 ? giftCardNavigationMenu : null,
    navigationMenu: nationalExperienceNavigationMenu !== null && nationalExperienceNavigationMenu !== void 0 ? nationalExperienceNavigationMenu : null,
    centres: centres !== null && centres !== void 0 ? centres : []
  };
  if (options.context === 'national') {
    return _objectSpread(_objectSpread({}, baseItems), {}, {
      primaryLinks: nationalExperienceNavLinks || [],
      tertiaryLinks: [{
        label: 'The Edit',
        url: '/the-edit'
      }, ...(giftCardNavLinks || [])]
    });
  }
  if (options.context === 'gift-cards') {
    return _objectSpread(_objectSpread({}, baseItems), {}, {
      primaryLinks: giftCardNavigationMenu.map(item => buildLinkItem(item, options.context)),
      tertiaryLinks: []
    });
  }
  if (options.context === 'centre') {
    var _centreData$navigatio;
    // temporarily fetch the centre data when we have a slug
    // eventually, all calls to fetchStaticData should provide the centre data
    const centreData = typeof options.centre === 'string' ? await getCentreDetails(client, {
      slug: options.centre,
      country
    }) : options.centre;
    if (centreData === null) {
      throw new Error('Centre not found');
    }
    const centre = _objectSpread(_objectSpread({}, centreData), {}, {
      navigationMenu: ((_centreData$navigatio = centreData.navigationMenu) !== null && _centreData$navigatio !== void 0 ? _centreData$navigatio : []).map(item => _objectSpread(_objectSpread({}, item), {}, {
        key: item.title
      }))
    });
    return _objectSpread(_objectSpread({}, baseItems), {}, {
      centre,
      primaryLinks: centre.navigationMenu.map(item => buildLinkItem(item, options.context)),
      tertiaryLinks: [{
        label: 'Opening hours',
        url: "/".concat(centre.slug, "/opening-hours")
      }, ...(giftCardNavLinks || [])]
    });
  }
  throw new TypeError("Unknown context");
}

// keep existing helpers interface for backwards compatibility
export const fetchNationalStaticData = async (client, options) => fetchStaticData(client, _objectSpread({
  context: 'national'
}, options));
export const fetchCentreStaticData = async (client, options) => fetchStaticData(client, _objectSpread({
  context: 'centre'
}, options));
export const fetchGiftcardsStaticData = async (client, options) => fetchStaticData(client, _objectSpread({
  context: 'gift-cards'
}, options));